/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sound_Sensor_Param_HelpInputs */



/**
* | output |
* | --- |
* | "Noise detection contributes to automatic schedule generation. Disabling the noise sensor may, in some cases, reduce accuracy." |
*
* @param {Sound_Sensor_Param_HelpInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const sound_sensor_param_help = /** @type {((inputs?: Sound_Sensor_Param_HelpInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sound_Sensor_Param_HelpInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Noise detection contributes to automatic schedule generation. Disabling the noise sensor may, in some cases, reduce accuracy.")
	return /** @type {LocalizedString} */ ("La détection de bruit contribue à la génération automatique des plannings. Désactiver le capteur de bruit peut, dans certains cas, en dégrader la précision.")
});